import React from 'react';
import { IMAGES } from '../data/site';
const HERO_ALT = 'Concept image of two Kosin’s Glass service vans parked outside a commercial storefront';
const textShadow = {
  textShadow: '0 1px 14px rgba(0, 0, 0, 0.55)'
};
export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative isolate w-full overflow-hidden bg-kosin-charcoal" data-id="element-141" data-mp="9ipbb96819z2">
      <picture data-id="element-142" data-mp="1297ba1bnev89">
        <source media="(min-width: 1024px)" srcSet={IMAGES.heroWide} width={2172} height={724} data-id="element-143" data-mp="129qwps0ic1r1" />
        <img src={IMAGES.heroMobile} alt={HERO_ALT} width={1086} height={1448} className="absolute inset-0 h-full w-full object-cover object-center sm:object-bottom lg:object-[center_58%]" data-id="element-144" data-mp="x8b9btauxj5h" />
      </picture>

      <div className="relative mx-auto flex min-h-[545px] max-w-shell flex-col justify-start px-[18px] pb-8 pt-6 sm:min-h-[clamp(720px,95vw,970px)] sm:px-6 sm:pt-10 lg:min-h-[500px] lg:justify-center lg:py-14" data-id="element-145" data-mp="3d2l8d8tzsyz4">
        <div className="max-w-[560px] lg:max-w-[46%]" data-id="element-146" data-mp="3j924znc7pov0">
          <p className="text-[15px] font-semibold text-white sm:text-[16px]" style={textShadow} data-id="element-147" data-mp="3o7c0jz1umrh5">
            Kosin’s Glass
          </p>
          <h1 id="hero-heading" className="mt-2.5 text-[34px] font-bold leading-[1.1] text-white sm:text-[40px] lg:text-[44px] xl:text-[52px]" style={textShadow} data-id="element-148" data-mp="39cpcutwbfj2d">
            Glass repair, replacement &amp; custom glass
          </h1>
          <p className="mt-4 max-w-[480px] text-[17px] leading-relaxed text-white sm:text-[18px]" style={textShadow} data-id="element-149" data-mp="35a2fyeksf7yb">
            For your vehicle, home and business in Southeast Michigan.
          </p>

          <div className="mt-6 flex flex-col gap-3 min-[360px]:flex-row sm:items-center" data-id="element-150" data-mp="2hjf6vpz4yca6">
            <a href="#quote" className="focus-light flex-1 rounded bg-kosin-red px-4 py-3.5 text-center text-[16px] font-semibold text-white hover:bg-kosin-bright transition-colors duration-150 ease-kosin sm:flex-none sm:px-6" data-id="element-151" data-mp="2lkqxnytqx3jy">
              Get a free quote
            </a>
            <a href="#services" className="focus-light flex-1 rounded border border-white/80 bg-kosin-charcoal/30 px-4 py-3.5 text-center text-[16px] font-semibold text-white hover:bg-white hover:text-kosin-charcoal transition-colors duration-150 ease-kosin sm:flex-none sm:px-6" data-id="element-152" data-mp="iboywmxo6qvf">
              Explore services
            </a>
          </div>
        </div>
      </div>
    </section>;
}